import { Navigation, Virtual } from "swiper";
import { SwiperSlide } from "swiper/react";
import { FC, memo } from "react";
import { VIEW_PRODUCTS_GRID } from "@/utils/constants";
import { cssProductSlider, cssSlideActive } from "./StyledProductsSlider";
import type { ProductsSliderPropsType } from "./types";
import { SwiperWrapper } from "../../Swiper/SwiperWrapper";
import { Product } from "../Catalog/Product";
export type DesktopProductsSliderPropsType = Pick<ProductsSliderPropsType, "responsiveExtends" | "variantArrow" | "products" | "slidesPerView" | "placementArrow" | "productImageConfig" | "isAbsoluteNav" | "virtual" | "extendNavigation" | "withNavigation">;
const Desktop: FC<DesktopProductsSliderPropsType> = memo(({
  responsiveExtends,
  products,
  variantArrow,
  placementArrow,
  slidesPerView = 4,
  productImageConfig,
  virtual,
  isAbsoluteNav,
  extendNavigation,
  withNavigation
}) => {
  return <SwiperWrapper className={cssProductSlider} slidesPerView={slidesPerView} spaceBetween={0} updateOnWindowResize breakpoints={responsiveExtends} modules={[Navigation, Virtual]} autoHeight={false} slideActiveClass={cssSlideActive} variantArrow={variantArrow} placementArrow={placementArrow} resistanceRatio={0} rewind isAbsoluteNav={isAbsoluteNav} virtual={virtual} extendNavigation={extendNavigation} withNavigation={withNavigation}>
        {products.map((p, i) => <SwiperSlide key={p.uuid || i} virtualIndex={i}>
            <Product view={VIEW_PRODUCTS_GRID} product={p} categories={(p.categories || []).join(", ")} disabledHover image={productImageConfig} />
          </SwiperSlide>)}
      </SwiperWrapper>;
});
Desktop.displayName = "Desktop";
export { Desktop };